import { useErrorsState } from './store';

export const useErrorsSelectors = () => {
  const {
    errorsState: { current },
  } = useErrorsState();

  return { current };
};
